import router from 'vue-router'
export default {
  getUrl (val) {
    var url = ''
    if (val == '1') { // 职称教育
      url = '/continueEdu'
    } else if (val == '2') { // 安全教育
      url = '/byl'
    } else if (val == '3') { // 企业内训
      url = '/entrain'
    } else if (val == '4') { // 党建教育
      url = '/byl'
    } else { // 默认白玉兰
      url = '/byl'
    }
    return url;
  },
  navTo (href) {
    if (href) {
      if (this.isInternal(href)) {
        router.push({path: this.createRoute(href)})
      } else {
        window.open((href.indexOf('http') <= 0) ? 'http://' + href : href, '_blank')
      }
    }
  },
  isInternal (href) {
    return href.split('/')[0] == 'internalink'
  },
  createRoute (href) {
    let isInternal = this.isInternal(href)
    if (isInternal) {
      let t = this.createResourceRoute(href.split('/')[1])
      return t + '/' + href.split('/')[2]
    } else {
      return href
    }
  },
  createResourceRoute (c) {
    switch (c) {
      case '1': {
        return '/plan'
      }
      case '2': {
        return '/courseDetail'
      }
      case '3': {
        return '/enroll'
      }
      case'4': {
        return '/kb'
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/orgurl.js